import { css } from 'emotion'
import { Link } from './..'

export const SearchBarStyle = css({
  position: 'relative',
  margin: '2rem 0rem',
  '@media (min-width: 1024px)': {
    margin: '4rem 0rem 2rem',
  },
  '.form': {
    position: 'relative',
  },
  'input[type="text"]': {
    color: 'white !important',
   
    '& + label, &:focus + label': {
      color: 'white !important',
      whiteSpace: 'nowrap',
    },
  },
  'button': {
    position: 'absolute',
    top: '50%',
    right: 0,
    ...Link,
    color: 'white',
    padding: '0px',
    transform: 'translateY(-50%)',
    zIndex: 2,
    opacity: 0.5,
    transition: 'opacity 400ms ease',
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/searchBar.js